import http from 'hub-http/clients/apiClient';
export async function enrichList(context) {
  const {
    listId,
    overwrite,
    enrichAssociations
  } = context;
  return await http.post(`enrichment-platform/v1/list/updates/apply/${listId}?shouldOverwrite=${overwrite ? 'true' : 'false'}&enrichAssociated=${enrichAssociations ? 'true' : 'false'}`);
}